/**
 * La API GET /api/cables incluye origen/destino como objetos { id, tipo, nombre }.
 * El front a veces asume strings; estas funciones normalizan al UUID del nodo.
 */
export function cableOrigenId(cable: {
  origen?: unknown
  origenId?: string
}): string | undefined {
  const raw = cable.origenId ?? cable.origen
  if (raw == null || raw === '') return undefined
  if (typeof raw === 'string') return raw
  if (typeof raw === 'object' && raw !== null && 'id' in raw) {
    return String((raw as { id: string }).id)
  }
  return undefined
}

export function cableDestinoId(cable: {
  destino?: unknown
  destinoId?: string
}): string | undefined {
  const raw = cable.destinoId ?? cable.destino
  if (raw == null || raw === '') return undefined
  if (typeof raw === 'string') return raw
  if (typeof raw === 'object' && raw !== null && 'id' in raw) {
    return String((raw as { id: string }).id)
  }
  return undefined
}

export function cableTouchesNode(
  cable: { origen?: unknown; origenId?: string; destino?: unknown; destinoId?: string },
  nodeId: string
): boolean {
  const o = cableOrigenId(cable)
  const d = cableDestinoId(cable)
  return o === nodeId || d === nodeId
}

/**
 * Un cable tiene dos puntas físicas independientes (origen y destino del
 * propio Cable). Esta función dice cuál de las dos es la que toca `nodeId`,
 * para saber qué extremo de cada fibra hay que leer/escribir en un empalme,
 * una entrada de splitter, etc. Devuelve `null` si el cable no toca ese nodo,
 * o si toca los dos lados con el mismo id (cable en bucle sobre sí mismo).
 */
export function cableEndpointAtNode(
  cable: { origen?: unknown; origenId?: string; destino?: unknown; destinoId?: string },
  nodeId: string
): 'origen' | 'destino' | null {
  const o = cableOrigenId(cable)
  const d = cableDestinoId(cable)
  if (o === nodeId && d === nodeId) return null
  if (o === nodeId) return 'origen'
  if (d === nodeId) return 'destino'
  return null
}
